import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const DonutChart = ({PieChartData}) => {
  const [citySales, setCitySales] = useState({
    cities: [],
    sales: [],
  });

  // Simulate API call
  useEffect(() => {
    // This would be your API response
  

    // Transform the data into arrays for chart
    const transformedData = {
      cities: PieChartData.map(item => item.area), // Extract areas as city labels
      sales: PieChartData.map(item => parseInt(item.sales, 10)), // Convert sales to numbers
    };

    setCitySales(transformedData);
  }, []);

  const totalSales = citySales.sales.reduce((acc, curr) => acc + curr, 0); // Calculate total sales

  const chartData = {
    series: citySales.sales, // Sales values
    options: {
      chart: {
        type: 'donut',
        height: 350,
      },
      labels: citySales.cities, // City names
      plotOptions: {
        pie: {
          donut: {
            size: '70%', // Donut size
            labels: {
              show: true,
              total: {
                show: true,
                label: 'Total',
                formatter: () => `${totalSales} Sales`, // Display total sales count
                fontSize: '18px',
                fontWeight: 600,
              },
            },
          },
        },
      },
      fill: {
        colors: ['#FF4560', '#00E396', '#39c834ff', '#FEB019', '#775DD0'], // Solid colors for each slice
      },
      legend: {
        position: 'bottom', // Place the legend at the bottom
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
      tooltip: {
        y: {
          formatter: (val) => `${val} sales`, // Tooltip to display sales count
        },
      },
    },
  };

  return (
    <div className="donut-chart-container">
      <h6>Sales by City</h6>
      <div style={{ height: '350px' }}>
        <Chart options={chartData.options} series={chartData.series} type="donut" height={350} />
      </div>
    </div>
  );
};

export default DonutChart;
